var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
let SignInScope = class SignInScope extends Scope {
    constructor() {
        super(...arguments);
        this.email = '';
        this.password = '';
        this.busy = false;
        this.onEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onSignIn = Scope.ASYNC_ACTION;
        /** Os dois caminhos que saem da porta, e que a reescrita tinha perdido. */
        this.onForgotPassword = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SignInScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SignInScope.prototype, "password", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SignInScope.prototype, "busy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SignInScope.prototype, "error", void 0);
SignInScope = __decorate([
    Observable
], SignInScope);
export { SignInScope };
//# sourceMappingURL=auth.scope.js.map